module.exports = __webpack_public_path__ + "static/media/m_faceshape_oval.db009c9e.png";